/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bell_Activity_PricesInputs */

const en_bell_activity_prices = /** @type {(inputs: Bell_Activity_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`prices changed`)
};

/**
* | output |
* | --- |
* | "prices changed" |
*
* @param {Bell_Activity_PricesInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const bell_activity_prices = /** @type {((inputs?: Bell_Activity_PricesInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bell_Activity_PricesInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_bell_activity_prices(inputs)
});